module.exports = __webpack_public_path__ + "img/estrada_velha4.54fabb32.jpg";